import { NgModule } from '@angular/core';
import { MainAvailabilityComponent } from "./components/main-availability.component";
import { DetailAvailabilityComponent } from "./components/detail-availability.component";
import { CalendarAvailabilityComponent } from "./components/dummy/calendar-availability.component";
import { CalendarDetailComponent } from "./components/dummy/calendar-detail.component";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AvailabilityRoutes } from './availability.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AvailabilityService } from "../../injections/availability.service";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { SharedModule } from "../../common/shared.module";
import { TooltipModule } from 'ngx-bootstrap';
import { TooltipComponent } from '../../common/tooltip/tooltip.component';




@NgModule({
  declarations: [MainAvailabilityComponent, DetailAvailabilityComponent, CalendarAvailabilityComponent, TooltipComponent, CalendarDetailComponent],
  imports: [
    CommonModule,
    AvailabilityRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpModule,
    TooltipModule.forRoot(),
    SharedModule
  ],
  providers: [AvailabilityService]
})

export class AvailabilityModule{} 


// WEBPACK FOOTER //
// ./src/app/modules/availability/availability.module.ts